import { FC, ReactNode } from 'react'
import { Box, Dialog, Divider, IconButton, Typography } from '@mui/material'
import ChevronLeft from '@mui/icons-material/ChevronLeft'

type FullScreenSheetProps = {
  open: boolean
  onClose: () => void
  children: ReactNode
  /** aria-label for the back/close button. */
  closeAriaLabel: string
}

/**
 * Full-screen mobile sheet: a `Dialog` with a back-chevron header (leaves
 * without choosing) and a scrollable body. Shared host for below-`smxl`
 * surfaces whose desktop counterpart is a drawer/popover.
 */
const FullScreenSheet: FC<FullScreenSheetProps> = ({
  open,
  onClose,
  children,
  closeAriaLabel,
}) => (
  <Dialog
    fullScreen
    open={open}
    onClose={onClose}
    PaperProps={{ sx: { display: 'flex', flexDirection: 'column' } }}
  >
    {/* Back header lets the user leave the full-screen sheet without choosing. */}
    <Box display="flex" alignItems="center" gap={1} padding={1} flexShrink={0}>
      <IconButton onClick={onClose} aria-label={closeAriaLabel}>
        <ChevronLeft />
      </IconButton>
      <Typography variant="subtitle1" fontWeight={600}>
        Back
      </Typography>
    </Box>
    <Divider />
    {/* minHeight 0 lets this flex child shrink so its own scroll engages
        instead of the dialog paper overflowing. */}
    <Box flex={1} minHeight={0} overflow="auto">
      {children}
    </Box>
  </Dialog>
)

export default FullScreenSheet
